import React from "react";
import { Route, Routes } from "react-router-dom";
import OoraTrafficDataset from "../Components/Oora Traffic Data Set/ooraTrafficData";
import ViewOoraTrafficDataset from "../Components/Oora Traffic Data Set/viewOoraTrafficData";
import OoraJamPatches from "../Components/Oora Traffic Data Set/ooraJamPatches";

const OoraTrafficDatasetRoutes = () => {
  return (
    <Routes>
      <Route path="/oora-traffic-dataset" element={<OoraTrafficDataset />} />
      <Route path="/oora-traffic-dataset/view/:id" element={<ViewOoraTrafficDataset />} />
      <Route path="/oora-traffic-dataset/patches" element={<OoraJamPatches />} />
    </Routes>
  );
};

export default OoraTrafficDatasetRoutes;